import React from 'react';
import { HotelTile } from './HotelTile';
import { Box, Divider } from '@withjoy/joykit';
import { useLayout } from '../../layouts/LayoutProvider';

import { ReservedRoomBlocks, LeadDestination } from '../../widgets/Custom/Custom.types';

interface HotelTileListProps {
  destination: LeadDestination;
  hotelTileListData: ReservedRoomBlocks;
  eventPhoto: string;
  eventHandle: string;
  handleCoupleNoteOpen?: () => void;
  isCoupleNoteOpen?: boolean;
}

const HotelTileList: React.FC<HotelTileListProps> = ({ destination, hotelTileListData, eventPhoto, eventHandle, handleCoupleNoteOpen, isCoupleNoteOpen }) => {
  const { layout } = useLayout();
  const isBrannan = layout === 'brannan';

  const sortByFavorite = (list: ReservedRoomBlocks): ReservedRoomBlocks => {
    const isFavorite = list.find(hotel => hotel.isFavorite === true);

    if (isFavorite) {
      const filtered = list.filter(item => item.isFavorite !== true);
      return [{ ...isFavorite }, ...filtered];
    }
    return list;
  };

  const sortedHotelList = sortByFavorite(hotelTileListData);

  return (
    <>
      {sortedHotelList.map((hotel, idx) => {
        return (
          <Box key={hotel.id} id={hotel.id} width="100%">
            <HotelTile
              {...hotel}
              isFirst={idx === 0}
              isLast={idx === hotelTileListData.length - 1}
              locationInfo={destination}
              eventPhoto={eventPhoto}
              handleCoupleNoteOpen={handleCoupleNoteOpen}
              isCoupleNoteOpen={isCoupleNoteOpen}
              eventHandle={eventHandle}
            />
            {idx < hotelTileListData.length - 1 && <Divider marginBottom={isBrannan ? { _: 0, sm2: 8 } : 0} />}
          </Box>
        );
      })}
    </>
  );
};

HotelTileList.displayName = 'HotelTileList';

export { HotelTileList };
